module.exports = __webpack_public_path__ + "img/83.10.pH.a11de2a2.png";